import { GET_PERMISSION_URL, REQ_EMAIL, RESET_PASSWORD, USER_LOGIN_URL, RESEND_MAIL, USER_LOGOUT } from "../api";
import axiosInstance from "../axiosInstance";

export const userLogin = (props) => onResponse => {
    try {
        axiosInstance.post(USER_LOGIN_URL, props.formData)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};
export const getPermissionList = () => onResponse => {
    try {
        axiosInstance.get(GET_PERMISSION_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};

export const getEmailRequest = (props) => onResponse => {
    try {
        axiosInstance.post(REQ_EMAIL, props)
            .then((response) => {
                onResponse(response.data)
            })
            .catch((err) => {
                onResponse(err?.response?.data)
            })

    } catch (err) {

    }
}

export const resetPassword = (props) => onResponse => {
    try {
        axiosInstance.post(RESET_PASSWORD, props)
            .then((response) => {
                onResponse(response.data)
            })
            .catch((err) => {
                onResponse(err?.response?.data)
            })

    } catch (err) {

    }
}


export const userlogout = (props) => (onResponse) => {
    try {
        axiosInstance.post(USER_LOGOUT, props)
            .then((response) => {
                onResponse(response.data)
            }).catch((err) => {

            })
    } catch (err) {

    }
}

export const ResendMail = (props) => onResponse => {
    try {
        axiosInstance.post(RESEND_MAIL, props)
            .then((response) => {
                onResponse(response.data)
            })
            .catch((err) => {
                onResponse(err?.response?.data)
            })

    } catch (err) { }
}